import 'css-chunksrc/client/scenes/workloads/header/sort/styles.scss';export default {
  "sort": "_sort_lgvts_1",
  "label": "_label_lgvts_9",
  "input": "_input_lgvts_15",
  "placeholder": "_placeholder_lgvts_31",
  "icon": "_icon_lgvts_39",
  "listRoot": "_listRoot_lgvts_47",
  "list": "_list_lgvts_47",
  "item": "_item_lgvts_63",
  "option": "_option_lgvts_76",
  "selected": "_selected_lgvts_83",
  "opened": "_opened_lgvts_96"
};